import React from 'react';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import apiClient, { WrappingApiClient } from 'libs/api/apiClient';
import { TLearningParams } from 'modules/learning';
import styled from 'styled-components';
import { device } from 'GlobalStyles';

const ExamLinkBtn = ({ content }: any) => {
  const { example_id }: TLearningParams = useParams();

  const postCountTheme = (params: any) => {
    return WrappingApiClient(apiClient.post('/drill/board/question_button', params));
  };

  const countingClickTheme = async () => {
    await postCountTheme({
      board_id: Number(example_id),
    });
  };

  return (
    <StyledPracticeQuiz>
      <div className='practiceQuizInformation'>
        <StyledPracticeQuizHeader>Career Step 오리지널 케이스</StyledPracticeQuizHeader>
        <StyledPracticeQuizIntroduction>
          예제와 유사한 케이스 문제를 직접 풀어보세요
        </StyledPracticeQuizIntroduction>
      </div>
      <Link
        to={`/case/quiz/view/${content}`}
        onClick={(e) => (content === null ? e.preventDefault() : countingClickTheme())}
      >
        <StyledPracticeQuizLinkBtn>문제 풀어보기</StyledPracticeQuizLinkBtn>
      </Link>
    </StyledPracticeQuiz>
  );
};

export default ExamLinkBtn;

const StyledPracticeQuiz = styled.article`
  width: 595px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 40px 0;
  padding-left: 15px;
  border-left: 4px solid #3cac40;

  .practiceQuizInformation {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }

  @media screen and ${device.md} {
    flex-direction: column;
    align-items: flex-start;
    width: 284px;
  }
`;

const StyledPracticeQuizHeader = styled.div`
  margin-bottom: 7px;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  color: #3cac40;
`;

const StyledPracticeQuizIntroduction = styled.div`
  color: #000000;
  line-height: 20px;
`;

const StyledPracticeQuizLinkBtn = styled.div`
  height: 100%;
  margin-top: 5px;
  padding: 10px 80px;
  border: 1px solid #3cac40;
  border-bottom: 2px solid #3cac40;
  border-radius: 8px;
  color: #3cac40;
  cursor: pointer;
`;
